import React from 'react';
import { motion } from 'framer-motion';
export function CircuitPattern({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full h-full ${className}`} data-id="element-152">
      <svg viewBox="0 0 300 400" className="w-full h-full opacity-30" data-id="element-153">
        <g stroke="#00e5ff" strokeWidth="1" fill="none" strokeOpacity="0.3" data-id="element-154">
          {/* Static Lines */}
          <path d="M50 50 L100 50 L150 100 L150 200 L200 250 L250 250" data-id="element-155" />
          <path d="M250 100 L200 100 L150 150 L50 150" data-id="element-156" />
          <path d="M100 350 L100 300 L150 250 L150 200" data-id="element-157" />

          {/* Nodes */}
          <circle cx="50" cy="50" r="3" fill="#00e5ff" data-id="element-158" />
          <circle cx="250" cy="250" r="4" fill="#0066ff" data-id="element-159" />
          <circle cx="250" cy="100" r="3" fill="#00e5ff" data-id="element-160" />
          <circle cx="50" cy="150" r="4" fill="#0066ff" data-id="element-161" />
          <circle cx="100" cy="350" r="3" fill="#00e5ff" data-id="element-162" />
          <circle cx="150" cy="200" r="5" fill="#00e5ff" fillOpacity="0.5" data-id="element-163" />
        </g>

        {/* Animated Pulses */}
        <motion.circle r="2" fill="#fff" animate={{
        cx: [50, 100, 150, 150, 200, 250],
        cy: [50, 50, 100, 200, 250, 250],
        opacity: [0, 1, 1, 1, 1, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-164" />
        <motion.circle r="2" fill="#fff" animate={{
        cx: [250, 200, 150, 50],
        cy: [100, 100, 150, 150],
        opacity: [0, 1, 1, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
        delay: 1
      }} data-id="element-165" />
      </svg>
    </div>;
}